import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams } from "react-router";

import { createStyles, makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import * as actions from "../../redux/actions/index";
import prettyAddress from "../../util/prettyAddress";

import logo from "../../images/reportonce-logo.svg";
import ActionInfoBlock from "./ActionInfoBlock";
import AddNewCommentBlock from "./AddNewCommentBlock";
import ViewEditCommentsBlock from "./ViewEditCommentsBlock";

const useStyles = makeStyles((theme) =>
    createStyles({
        container: {
            paddingBottom: theme.spacing(3),
            paddingTop: theme.spacing(3),
        },
    })
);

export default function EditListing(props) {
    const loading = useSelector((state) => state.listing.loading);
    const listing = useSelector((state) => state.listing.details);
    const listingId = useSelector((state) => state.listing.id);
    const error = useSelector((state) => state.listing.error);
    const errorMessage = useSelector((state) => state.listing.errorMessage);
    const errorCode = useSelector((state) => state.listing.errorCode);
    const dispatch = useDispatch();
    const params = useParams();
    const classes = useStyles();

    const handle401 = () => {
        dispatch(actions.userLogout());
        return <Redirect to="/login" />;
    };

    if (!loading) {
        // If a listing is loading don't try to update anything.
        if (params.id !== listingId) {
            // Check if the loaded listing matches the listing id in the URL.
            dispatch(actions.loadSpecificListing(params.id));
        }
    }

    let listingAddress = "Loading\u2026";
    if (!loading && !error && listing !== null) {
        listingAddress = prettyAddress(listing, true);
    }
    return (
        <Container className={classes.container} maxWidth="lg">
            {!error ? (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography
                            variant="h4"
                            gutterBottom
                            dangerouslySetInnerHTML={{ __html: listingAddress }}
                        ></Typography>
                    </Grid>
                    <ActionInfoBlock />
                    <AddNewCommentBlock />
                    <ViewEditCommentsBlock />
                </Grid>
            ) : errorCode === 401 ? (
                handle401()
            ) : (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h5" component="h1" gutterBottom>
                            Error
                        </Typography>
                        <Typography variant="body1" component="p" gutterBottom>
                            {errorMessage}
                        </Typography>
                        {errorCode ? (
                            <Typography
                                variant="body2"
                                component="p"
                                gutterBottom
                            >
                                Error code: {errorCode}
                            </Typography>
                        ) : null}
                    </Grid>
                </Grid>
            )}
            <img
                src={logo}
                alt="ReportOnce Logo"
                width="200"
                height="42"
                style={{ margin: "0 auto", display: "block" }}
            />
        </Container>
    );
}
